module.exports = __webpack_public_path__ + "img/2_87.45a3e81d.png";